import { Stack, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { auth, useAuth } from '../auth/firebase-auth';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from './home';
import Modal from 'react-bootstrap/Modal';

/* Login page component */
export const Login = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const inputEmailRef = useRef<HTMLInputElement>(null);
  const inputPasswordRef = useRef<HTMLInputElement>(null);

  function loginUser() {
    if (inputEmailRef.current && inputPasswordRef.current) {
      const email = inputEmailRef.current.value;
      const password = inputPasswordRef.current.value;

      if (!email.length || !password.length) {
        handleShow();
        return;
      }

      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential: { user: any }) => {
          navigate('/dashboard');
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  return (
    <>
      {currentUser ? (
        <Home />
      ) : (
        <Stack gap={3}>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>Please enter valid email and password</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <br></br>
          <h4>Login with your account</h4>

          <Form.Label htmlFor="inputEmail">Email</Form.Label>
          <Form.Control
            type="email"
            id="inputEmail"
            aria-describedby="passwordHelpBlock"
            ref={inputEmailRef}
          />
          <Form.Label htmlFor="inputPassword">Password</Form.Label>
          <Form.Control
            type="password"
            id="inputPassword"
            aria-describedby="passwordHelpBlock"
            ref={inputPasswordRef}
          />
          <Form.Text id="passwordHelpBlock" muted>
            Your password must be 8-20 characters long, contain letters and
            numbers, and must not contain spaces, special characters, or emoji.
          </Form.Text>
          <Button onClick={() => loginUser()} variant="dark">
            Login
          </Button>
        </Stack>
      )}
    </>
  );
};
